import { HexColor, ValueObject } from '@nx-smartmonkey/shared/domain';
import { RatingTags } from '../customersSurvey/CustomersSurvey';

interface AnalyticsCustomersSurveyProps {
  stop_id: string;
  driver_id: string;
  vehicle_id?: string;
  plan_id: string;
  project_id: string;
  vehicle_color?: HexColor;
  stop_label: string;
  rating: number;
  rating_tag?: RatingTags;
  comments?: string;
  stop_order?: number;
  created_at?: Date;
}

export class AnalyticsCustomersSurvey extends ValueObject<AnalyticsCustomersSurveyProps> {
  get stop_id(): string {
    return this.props.stop_id;
  }
  get driver_id(): string {
    return this.props.driver_id;
  }
  get vehicle_id(): string | undefined {
    return this.props.vehicle_id;
  }
  get plan_id(): string {
    return this.props.plan_id;
  }
  get project_id(): string {
    return this.props.project_id;
  }
  get vehicle_color(): HexColor | undefined {
    return this.props.vehicle_color;
  }
  get stop_label(): string {
    return this.props.stop_label;
  }
  get rating(): number {
    return this.props.rating;
  }
  get rating_tag(): RatingTags | undefined {
    return this.props.rating_tag;
  }
  get comments(): string | undefined {
    return this.props.comments;
  }
  get stop_order(): number | undefined {
    return this.props.stop_order;
  }
  get created_at(): Date | undefined {
    return this.props.created_at;
  }
  private constructor(props: AnalyticsCustomersSurveyProps) {
    super(props);
  }

  static create(props: AnalyticsCustomersSurveyProps): AnalyticsCustomersSurvey {
    return new AnalyticsCustomersSurvey(props);
  }
}
